(function($) {
  "use strict";

  jQuery(document).ready(function(){

    /*--------------------------
    1. Newsletter Popup
    ---------------------------*/
    setTimeout(function () {
        $('.popup_wrapper').css({
            "opacity": "1",
            "visibility": "visible"
        });
        $('.popup_off').on('click', function () {
            $(".popup_wrapper").fadeOut(500);
        })
    }, 2500);

    /*----------------------------
    2. Mobile Menu Activation
    -----------------------------*/
    jQuery('.mobile-menu nav').meanmenu({
        meanScreenWidth: "991",
    });

    /*----------------------------
    3. Tooltip Activation
    ------------------------------ */
    $('.pro-actions a').tooltip({
        animated: 'fade',
        placement: 'top',
        container: 'body'
    });
    
    

    /*----------------------------
    4. Checkout Page Activation
    -----------------------------*/
    $('#showlogin').on('click', function () {
        $('#checkout-login').slideToggle();
    });
    $('#showcoupon').on('click', function () {
        $('#checkout_coupon').slideToggle();
    });
    $('#cbox').on('click', function () {
        $('#cbox_info').slideToggle();
    });
    $('#ship-box').on('click', function () {
        $('#ship-box-info').slideToggle();
    });

    /*----------------------------------------------------
    6. Our Product Activation
    -----------------------------------------------------*/
    $('.our-pro-active').owlCarousel({
        loop: true,
        nav: true,
        dots: false,
        
        smartSpeed: 1500,
        navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
        margin: 20,
        responsive: {
            0: {
                items: 1,
                autoplay: true,
                smartSpeed: 500
            },
            480: {
                items: 2
            },
            768: {
                items: 2
            },
            992: {
                items: 3
            },
            1200: {
                items: 4
            }
        }
    })

    /*-------------------------------
     7. Blog Activation
    ---------------------------------*/
    $('.blog-activation').owlCarousel({
        loop: true,
        nav: true,
        
        dots: false,
        navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
        smartSpeed: 700,
        margin: 30,
        responsive: {
            0: {
                items: 1,
                autoplay: true,
                smartSpeed: 500
            },
            768: {
                items: 2
            },
            992: {
                items: 3
            },
            1200: {
                items: 3
            }
        }
    })
    
    /*----------------------------------------------------
    8. daily-deal-active Activation
    -----------------------------------------------------*/
    $('.daily-deal-active').owlCarousel({
        loop: true,
        nav: true,
        
        dots: false,
        smartSpeed: 500,
        navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
        margin: 20,
        responsive: {
            0: {
                items: 1,
                autoplay: true,
                smartSpeed: 300
            },
            480: {
                items: 2
            },
            768: {
                items: 2
            },
            992: {
                items: 2
            },
            1200: {
                items: 2
            }
        }
    })
    
    /*----------------------------------------------------
    9. single deal Activation
    -----------------------------------------------------*/
    $('.single-deal-active').owlCarousel({
        loop: true,
        nav: true,
        
        dots: false,
        smartSpeed: 1000,
        navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
        margin: 20,
        items:1,
        responsive: {
            0: {
                items: 1,
                autoplay: true,
                smartSpeed: 300
            },
            576: {
                items: 2
            },
            992: {
                items: 1
            },
            1200: {
                items: 1
            }
        }
    })
    
    /*----------------------------------------------------
    10. Tripple Pro Activation
    -----------------------------------------------------*/
    $('.tripple-pro-active').owlCarousel({
        loop: true,
        nav: true,
        
        dots: false,
        smartSpeed: 500,
        navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
        margin: 20,
        responsive: {
            0: {
                items: 1,
                autoplay: true,
                smartSpeed: 300
            },
            480: {
                items: 2
            },
            768: {
                items: 2
            },
            992: {
                items: 3
            },
            1200: {
                items: 3
            }
        }
    })
    
    /*----------------------------------------------------
    11. daily-deal-active Activation
    -----------------------------------------------------*/
    $('.arrival-pro-active').owlCarousel({
        loop: true,
        nav: true,
        
        dots: false,
        smartSpeed: 500,
        navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
        margin: 20,
        responsive: {
            0: {
                items: 1,
                autoplay: true,
                smartSpeed: 300
            },
            480: {
                items: 2
            },
            768: {
                items: 1
            },
            992: {
                items: 2
            },
            1200: {
                items: 2
            }
        }
    })
    
    /*----------------------------------------------------
    12. Categorie Products Activation
    -----------------------------------------------------*/
    $('.categorie-pro-active').owlCarousel({
        loop: true,
        nav: true,
        
        dots: false,
        smartSpeed: 500,
        navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
        margin: 20,
        responsive: {
            0: {
                items: 1,
                autoplay: true,
                smartSpeed: 300
            },
            480: {
                items: 2
            },
            768: {
                items: 3
            },
            992: {
                items: 3
            },
            1200: {
                items: 4
            }
        }
    })
    
    /*-------------------------------------
    13. Thumbnail Product activation
    --------------------------------------*/
    $('.thumb-menu').owlCarousel({
        loop: true,
        navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
        margin: 15,
        smartSpeed: 500,
        
        nav: true,
        dots: false,
        responsive: {
            0: {
                items: 3,
                autoplay: true,
            },
            768: {
                items: 3
            },
            1000: {
                items: 3
            }
        }
    })
    $('.thumb-menu a').on('click', function () {
        $('.thumb-menu a').removeClass('active');
    })

    /*----------------------------
    14. Testmonial Activation
    -----------------------------*/
    $(".testmonial-active").owlCarousel({
        loop: true,
        margin: 0,
        smartSpeed: 500,
        nav: false,
        
        autoplay: false,
        items: 1,
        dots: true,
    });

    /*----------------------------
    15. Recent Post Activation
    -----------------------------*/
    $(".recent-post-active").owlCarousel({
        loop: true,
        margin: 0,
        
        smartSpeed: 500,
        nav: false,
        autoplay: false,
        items: 1,
        dots: false,
    });
    
    /*----------------------------------------------------
    16. Categorie Slider Activation
    -----------------------------------------------------*/
    $('.categorie-slider-active').owlCarousel({
        loop: true,
        nav: true,
        
        dots: false,
        smartSpeed: 1500,
        navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
        margin: 20,
        responsive: {
            0: {
                items: 1,
                autoplay: true,
                smartSpeed: 500
            },
            480: {
                items: 2
            },
            768: {
                items: 2
            },
            992: {
                items: 1
            },
            1200: {
                items: 1
            }
        }
    })
    

    /*----------------------------
    18. ScrollUp Activation
    -----------------------------*/
    $.scrollUp({
        scrollName: 'scrollUp', // Element ID
        topDistance: '550', // Distance from top before showing element (px)
        topSpeed: 1000, // Speed back to top (ms)
        animation: 'fade', // Fade, slide, none
        scrollSpeed: 900,
        animationInSpeed: 1000, // Animation in speed (ms)
        animationOutSpeed: 1000, // Animation out speed (ms)
        scrollText: '<i class="fa fa-angle-double-up" aria-hidden="true"></i>', // Text for element
        activeOverlay: false // Set CSS color to display scrollUp active point, e.g '#00FFFF'
    });

    /*----------------------------
    19. Sticky-Menu Activation
    ------------------------------ */
    $(window).on('scroll',function() {
        if ($(this).scrollTop() > 300) {
            $('.header-sticky').addClass("sticky");
        } else {
            $('.header-sticky').removeClass("sticky");
        }
    });

    //Lazayload js
    $("img.lazyload").lazyload();
        
    // Product grid color variant activation code. 
    
    $('.product-color li label').click(function(){
      var variantImage = jQuery(this).parent().find('.hidden a').attr('href');
      jQuery(this).parents('.product-wrapper').find('.popup_cart_image').attr({ src: variantImage }); 
      return false;
    });
    
    
    
	 //Single Product Dynamic Checkout Button
      $('#buy-now-check').on('click', function(){
        $(this).parent('.dynmiac_checkout--button').toggleClass('disabled');
      });
    


    $('.pro-qty').append('<a href="#" class="inc qty-btn">+</a>');
    $('.pro-qty').prepend('<a href="#" class= "dec qty-btn">-</a>');
    $('.qty-btn').on('click', function (e) {
      e.preventDefault();
      var $button = $(this);
      var oldValue = $button.parent().find('input').val();
      if ($button.hasClass('inc')) {
        var newVal = parseFloat(oldValue) + 1;
      } else {
        // Don't allow decrementing below zero
        if (oldValue > 0) {
          var newVal = parseFloat(oldValue) - 1;
        } else {
          newVal = 0;
        }
      }
      $button.parent().find('input').val(newVal);
    });


    
    
    
    
    	/*------- Category Menu start -------*/
	// Variables
	var categoryToggleWrap = $('.category-toggle-wrap');
	var categoryToggle = $('.category-toggle');
	var categoryMenu = $('.category-menu');
    
    var $window = $(window);

	// Category Menu Toggles
	function categorySubMenuToggle() {
		var screenSize = $window.width();
		if (screenSize <= 991) {
			$('.category-menu .menu-item-has-children > a').prepend('<span class="expand menu-expand">+</span>');
			$('.category-menu .menu-item-has-children ul').slideUp();
		} else {
			$('.category-menu .menu-item-has-children > a .menu-expand').remove();
			$('.category-menu .menu-item-has-children ul').slideDown();
		}
	}

	$(window).on({
		load: function () {
			categorySubMenuToggle();
		},
		resize: function () {
			categorySubMenuToggle();
		}
	});

	categoryToggle.on('click', function () {
		categoryMenu.slideToggle();
	});

	// Category Sub Menu
	$('.category-menu').on('click', 'li a, li a .menu-expand', function (e) {
		var $a = $(this).hasClass('menu-expand') ? $(this).parent() : $(this);
		if ($a.parent().hasClass('menu-item-has-children')) {
			if ($a.attr('href') === '#' || $(this).hasClass('menu-expand')) {
				if ($a.siblings('ul:visible').length > 0) $a.siblings('ul').slideUp();
				else {
					$(this).parents('li').siblings('li').find('ul:visible').slideUp();
					$a.siblings('ul').slideDown();
				}
			}
		}
		if ($(this).hasClass('menu-expand') || $a.attr('href') === '#') {
			e.preventDefault();
			return false;
		}
	});
	/*------- Category Menu end -------*/
	
    // Product grid color variant activation code. 
    
    $('.product-color li label').click(function(){
      var variantImage = jQuery(this).parent().find('.hidden a').attr('href');
      jQuery(this).parents('.product-wrapper').find('.popup_cart_image').attr({ src: variantImage }); 
      return false;
    });
    
    

          
      /* single product activation */
      var $OwlMenuProduct = $('.menu_product_contain');
      if($OwlMenuProduct.length > 0){
        $OwlMenuProduct.owlCarousel({
          loop: true,
          nav: true,
          
          autoplay: false,
          margin: 0,
          autoplayTimeout: 8000,
          items: 1,
          dots:false,
          navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
        });  
      };
    
    
    
    
    
    
    
    
    


  });
  
})(jQuery);



// Age verification



// document.addEventListener('DOMContentLoaded', () => {

//   const overlay = document.getElementById('age-verification-overlay');
//   const yesBtn = document.getElementById('age-yes');
//   const noBtn = document.getElementById('age-no');
//   const error = document.getElementById('age-error');

//   // Agar session me already verify kar chuka hai
//   if (sessionStorage.getItem('age_verified') === 'true') {
//     // overlay.classList.add('hidden');
//      if (overlay) {
//       overlay.remove(); // HTML bhi remove ho jayega
//     }
//     return;
//   }

//   // Popup open hone par scroll disable
//   document.body.classList.add('age-popup-open');

//   // YES button
//   yesBtn.addEventListener('click', () => {

//     // Error hide kar do agar pehle NO click kiya tha
//     error.style.display = 'none';

//     // Session save
//     sessionStorage.setItem('age_verified', 'true');

//     // Popup close
//     overlay.classList.add('hidden');

//     // Scroll enable
//     document.body.classList.remove('age-popup-open');

//   });

//   // NO button
//   noBtn.addEventListener('click', () => {

//     error.style.display = 'block';

//   });

// });
















document.addEventListener('DOMContentLoaded', () => {

  // Agar session me already verify kar chuka hai
  if (sessionStorage.getItem('age_verified') === 'true') {
    return;
  }

  // HTML Create
  document.body.insertAdjacentHTML('beforeend', `
    <div id="age-verification-overlay">
      <div id="age-verification-modal">

        <h2>Age Verification</h2>

        <p>
          This website contains age-restricted content.
          You must be 21 years or older to enter.
        </p>

        <div class="age-buttons">
          <button id="age-yes" type="button">Yes, I am 21+</button>
          <button id="age-no" type="button">No</button>
        </div>

        <div id="age-error" style="display:none;">
          Sorry, you are not eligible to enter this website.
        </div>

      </div>
    </div>
  `);

  const overlay = document.getElementById('age-verification-overlay');
  const yesBtn = document.getElementById('age-yes');
  const noBtn = document.getElementById('age-no');
  const error = document.getElementById('age-error');

  // Popup open hone par scroll disable
  document.body.classList.add('age-popup-open');

  // YES button
  yesBtn.addEventListener('click', () => {

    // Error hide kar do agar pehle NO click kiya tha
    error.style.display = 'none';

    // Session save
    sessionStorage.setItem('age_verified', 'true');

    // Popup remove
    overlay.remove();

    // Scroll enable
    document.body.classList.remove('age-popup-open');

  });

  // NO button
  noBtn.addEventListener('click', () => {

    error.style.display = 'block';

  });

});



